// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1___ac9fa74f5bded3163f5","cls2":"CollapsedActivityPreview-cls2__cc19f81b14993b88395d CollapsedActivityPreview-cls1___ac9fa74f5bded3163f5"};